import { Injectable } from '@angular/core';
import { Config, StoreService } from '@ddt-web/store-service';

@Injectable({
	providedIn: 'root'
})
export class ModelsBrowseStoreHelperService {

	constructor(private storeService: StoreService) { }

	public updateStoreFromResponseList<T>(targetUpdateStoreConfig: Config<T>, data: Array<any>, id: string = 'id'): void {
		if (data) {
			this.storeService.upsertMany(
				targetUpdateStoreConfig,
				data.map(res => Object.assign({ id: String(res[id]) }, res))
			);
		}
	}

	public updateStoreFromResponse<T>(targetUpdateStoreConfig: Config<T>, responseJson: T): void {
		this.storeService.upsertOne(targetUpdateStoreConfig, responseJson);
	}
}
